import React from 'react';
import PropTypes from 'prop-types';

import Tag from '@decisiv/ui-components/lib/components/Tag';

/** Which role the user holds in which account. */
export const PERMISSION_ASSIGNMENT = PropTypes.shape({
  account: PropTypes.string,
  permission: PropTypes.string,
});

// Colours cover the roles the mockups show; anything else falls back to the
// neutral tag rather than guessing a palette design has not specified.
//
// Deliberately not exported: callers go through roleTag, which is what keeps the
// list and the Edit User header colouring the same role the same way.
const ROLE_COLORS = {
  'Fleet Administrator': 'fizzyLime',
  'Dealer Administrator': 'warning',
  Member: 'success',
  Manager: 'roseGummy',
};

const NEUTRAL = 'licoriceMousse';

/**
 * A role name as its coloured tag.
 *
 * Shared so the users list's PERMISSIONS cell (PD-4063) and the Edit User header
 * (PD-4068) cannot drift into showing the same role in two different colours.
 */
const roleTag = (permission) => (
  <Tag
    color={ROLE_COLORS[permission] || NEUTRAL}
    palette="pastel"
    text={permission}
  />
);

export default roleTag;
